import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import EditProductModal from "./EditProductModal";

const ProductTable = ({ products, onEdit, onDelete }) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false); // Track if delete dialog is open
  const [productToDelete, setProductToDelete] = useState(null); // Track product to delete

  const handleEditClick = (product) => {
    setSelectedProduct(product);
    setIsEditModalOpen(true);
  };

  const handleDeleteClick = (productId) => {
    setProductToDelete(productId); // Set the product to delete
    setIsDeleteDialogOpen(true); // Open the confirmation dialog
  };

  const handleConfirmDelete = () => {
    onDelete(productToDelete); // Call the delete function with the selected product ID
    setIsDeleteDialogOpen(false); // Close the confirmation dialog
    setProductToDelete(null); // Clear the product to delete
  };

  const handleCancelDelete = () => {
    setIsDeleteDialogOpen(false); // Close the confirmation dialog without deleting
    setProductToDelete(null);
  };

  const handleModalClose = () => {
    setIsEditModalOpen(false);
    setSelectedProduct(null);
  };

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Price</TableCell>
            <TableCell>Description</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {products.length === 0 ? (
            <TableRow>
              <TableCell colSpan={5} style={{ textAlign: "center" }}>
                No matching products found.
              </TableCell>
            </TableRow>
          ) : (
            products.map((product) => (
              <TableRow key={product.id}>
                <TableCell>{product.id}</TableCell>
                <TableCell>{product.title.translations.en_us}</TableCell>
                <TableCell>${product.price_info.price.toFixed(2)}</TableCell>
                <TableCell>{product.description.translations.en_us}</TableCell>
                <TableCell>
                  <Button
                    variant="outlined"
                    onClick={() => handleEditClick(product)}
                  >
                    Edit
                  </Button>
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={() => handleDeleteClick(product.id)}
                    style={{ marginLeft: "8px" }}
                  >
                    Delete
                  </Button>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>

      {/* Edit Product Modal */}
      {selectedProduct && (
        <EditProductModal
          open={isEditModalOpen}
          onClose={handleModalClose}
          product={selectedProduct}
          onSave={(updatedProduct) => {
            onEdit(updatedProduct);
            handleModalClose();
          }}
        />
      )}

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={isDeleteDialogOpen}
        onClose={handleCancelDelete}
      >
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this product? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDelete} variant="outlined" color="secondary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} variant="contained" color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </TableContainer>
  );
};

export default ProductTable;
